<template>
  <modern-modal @close="$emit('close')">
    <template #header>
      <div class="title">{{ title }}</div>
      <div class="subtitle">{{ subtitle }}</div>
    </template>
    
    <template #body>
      <div v-if="loading" class="report-loading">
        <logo-loader :height="150" />
        <div class="loading-text">{{ $t('customers.seReports.modal.loading') }}</div>
      </div>
      <div v-else-if="error" class="report-error">
        <p>{{ error }}</p>
      </div>
      <div v-else class="report-content">
        <iframe
          ref="reportFrame"
          :srcdoc="reportContent"
          frameborder="0"
          width="100%"
          style="height: 70vh; border: 1px solid #eee; border-radius: 4px;"
        ></iframe>
      </div>
    </template>
  </modern-modal>
</template>

<script>
import ModernModal from '@/app/layout/components/ModernModal'
import LogoLoader from '@/app/shared/components/LogoLoader'
import { downloadReport } from '@/services/se-reports/SeReportsService'

export default {
  props: {
    customerId: {
      type: String,
      required: true
    },
    reportId: {
      type: String,
      required: true
    },
    reportName: {
      type: String,
      default: 'Report'
    }
  },

  data() {
    return {
      loading: true,
      error: null,
      reportContent: ''
    }
  },

  computed: {
    title() {
      return this.reportName
    },
    
    subtitle() {
      return this.$t('customers.seReports.modal.viewReport')
    }
  },

  mounted() {
    this.fetchReportContent()
  },

  methods: {
    fetchReportContent() {
      this.loading = true
      this.error = null
      
      downloadReport(
        this.customerId,
        this.reportId,
        'html',
        response => {
          // Convert blob to HTML string
          const reader = new FileReader()
          reader.onload = () => {
            this.reportContent = reader.result
            this.loading = false
          }
          reader.readAsText(response.data)
        },
        error => {
          console.error('Failed to load report content:', error)
          this.error = this.$t('customers.seReports.modal.error', { error: (error.response?.data?.message || error.message || 'Unknown error') })
          this.loading = false
        }
      )
    }
  },

  components: {
    ModernModal,
    LogoLoader
  }
}
</script>

<style lang="scss" scoped>
.report-loading, .report-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  
  .loading-text {
    margin-top: 15px;
    color: #666;
    font-size: 14px;
  }
}

.report-error {
  color: #dc3545;
  text-align: center;
}
</style>
